import { _js } from '@ifixit/localize';
import { Fragment, PropsWithChildren } from 'react';
import { Image, Box, Link } from '@chakra-ui/react';
import { MinimalDisclosure } from 'Guide/Schematics/Diagram/Logic/minimalDisclosure';

function SchematicThumbnail({
   thumbnailUrl,
   title,
   children,
   onOpen,
   isOpen,
}: PropsWithChildren<
   {
      thumbnailUrl: string;
      title: string;
   } & Pick<MinimalDisclosure, 'onOpen' | 'isOpen'>
>) {
   const altText = title ? _js('Schematic Diagram for %1', title) : _js('Schematic Diagram');

   return (
      <Fragment>
         <Link
            as="button"
            padding={0}
            margin={0}
            onClick={onOpen}
            position="relative"
            float={{ base: 'none', sm: 'left' }}
            width={{ base: '100%', sm: '178px' }}
            height={{ base: 'auto', sm: '170px' }}
            marginRight={{ base: 'auto', sm: '8px' }}
            marginLeft={{ base: 'auto', sm: '0px' }}
            marginBottom={{ base: '10px', sm: '10px' }}
            cursor="pointer"
            borderWidth={1}
            borderColor="gray.300"
            overflow="hidden"
            _hover={{
               borderColor: 'brand.200',
               transition: 'all 0.1s 0',
            }}
            role="group"
         >
            <Image src={thumbnailUrl} alt={altText} width="100%" />
            <Box
               as="span"
               display="block"
               textAlign="center"
               color="black"
               background="rgba(229, 229, 229, 0.9)"
               fontWeight="600"
               fontSize="14px"
               position="absolute"
               width="100%"
               bottom="0px"
               margin="0"
               padding="9px 4px"
               _groupHover={{
                  background: 'brand.200',
                  padding: '13px 4px',
                  transition: 'all 1s 0',
               }}
            >
               {title}
            </Box>
         </Link>
         {isOpen && children}
      </Fragment>
   );
}

export default SchematicThumbnail;
